// extracted by mini-css-extract-plugin
export default {"visuallyhidden":"table-view-favourite__visuallyhidden--Aqi4d","focusable":"table-view-favourite__focusable--rLO2K","result":"table-view-favourite__result--kFdzk"};